import { Action } from "easy-peasy";
import { IListConfing } from "../../definitionsNew/configs";
import { IMemberAccess, IOrgContract, IProjectInContractProps } from "./organization";

export enum ACCOUNT_TYPE {
  normal = "normal",
  superAdmin = "superAdmin",
}
export type TAcountType = ACCOUNT_TYPE.normal | ACCOUNT_TYPE.superAdmin;

export type TOrgRole = "user" | "admin";

export interface UserContractSimple {
  contractName: string;
  contractID: string;
}
export interface UserContract extends UserContractSimple {
  projects?: string[] | IProjectInContractProps[];
  id?: string;
}
export interface IUserFlage {
  [key: string]: boolean;
}

export interface IOrgFiledsConfigs {
  configName: string;
  config: IListConfing[];
}
export interface IorgRoleConfig {
  // ToDo dodać poprawne wartośc !!!!
  role: TOrgRole;
  status: string;
}
export interface IUserDetails {
  authenticated: boolean;
  uid?: string;
  accountType: TAcountType;
  loading: boolean;
  email: string;
  orgStatus: string;
  flags: IUserFlage[];
  lang: string;
  orgID: string;
  orgRole: string;
  contracts: UserContract[];
  configs: IOrgFiledsConfigs[];
}

export interface IUser {
  userDetails: IUserDetails;
  //actions
  clearUser: Action<IUser>;
  setAuthenticated: Action<IUser, boolean>;
  setUserDetails: Action<IUser, IUserDetails>;
  removeContractFromUser: Action<IUser, string>;
  editContractName: Action<IUser, { contractID: string; contractName: string }>;
  setOrgStatus: Action<IUser, string>;
  setLang: Action<IUser, string>;
  setConfing: Action<IUser, IOrgFiledsConfigs>;
  addContractToUser: Action<IUser, UserContract>;
  removeProjectFromUser: Action<IUser, { projectID: string }>;
  updateContractsInUser: Action<IUser,{ changes: IMemberAccess[], contracts: IOrgContract[]}>;
}
